import i18next from 'i18next';
import permissions from '../../../../permissions';
import Resources from '../../../../../components/Resources/List';
import ResourcesLogo from '../../../../../components/Shared/Icons/RecourcesLogo';

// const RESOURCE_ROUTE_LIST_DS = {
//   path: '/:currentAccountUuid/accounts/:accountUuid/resources',
//   exact: true,
//   additional: {
//     component: Resources,
//     protected: true,
//     title: i18next.t('titles:resources'),
//     icon: AllergiEndResourcesLogo,
//     permission: permissions.GET_RESOURCES,
//   },
// };

const RESOURCE_ROUTE_LIST = {
  path: '/:currentAccountUuid/resources',
  exact: true,
  additional: {
    component: Resources,
    protected: true,
    title: i18next.t('titles:resources'),
    icon: ResourcesLogo,
    permission: permissions.GET_RESOURCES,
  },
};

export const RESOURCE_ROUTES = {
  // ------- For child accounts ------
  // listDS: RESOURCE_ROUTE_LIST_DS,

  // ------- For current accounts ------
  list: RESOURCE_ROUTE_LIST,
};
